import React, { useState } from "react";
import { Pagination } from "antd";
import Listingnavbar from "../components/listingnavbar";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import EditdocpatternModal from "../modals/editdocpatternModal";
import AdddocpatternModal from "../modals/adddocpatternModal";

const DocpatternListing = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [iseditModalOpen, setiseditModalOpen] = React.useState(false);
  const [adddocpatternmodal, setadddocpatternmodal] = React.useState(false);
  const showeditModal = () => {
    setiseditModalOpen(true);
  };
  const showeaddModal = () => {
    setadddocpatternmodal(true);
  };
  const campaigndata = [
    {
      id: 1,
      doctype: "Test Doc Type 3 Public",
      Status: "Inactive",
      accesstype: "Private",
      createdby: "RTTool Super Admin (Super Admin)",
    },
    {
      id: 2,
      doctype: "Test Doc Type 3 Public",
      Status: "Inactive",
      accesstype: "Private",
      createdby: "RTTool Super Admin (Super Admin)",
    },
    {
      id: 3,
      doctype: "Test Doc Type 3 Public",
      Status: "Active",
      accesstype: "Private",
      createdby: "RTTool Super Admin (Super Admin)",
    },
    {
      id: 4,
      doctype: "Test Doc Type 3 Public",
      Status: "Active",
      accesstype: "Private",
      createdby: "RTTool Super Admin (Super Admin)",
    },
  ];
  const getStatusBgColor = (status) => {
    return status === "Active" ? "#D2F3CF" : "#F5CDCD";
  };
  const getStatusColor = (status) => {
    return status === "Active" ? "#1FC510" : "#DC5050";
  };
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const visibleData = campaigndata.slice(startIndex, endIndex);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  function itemRender(current, type, originalElement) {
    if (type === "prev") {
      return <a>{"<<"} Previous</a>;
    }

    if (type === "next") {
      return <a>Next {">>"}</a>;
    }

    return null;
  }
  return (
    <>
      <Listingnavbar />
      <div className="client-listing-main">
        <h2 className="text-medium-black roboto-family text-center">
          DOCUMENT PATTERN LIST
        </h2>
        <div className="listing-top-container d-flex space-between">
          <div
            className="back-btn v-center h-center gap-2 cursor-pointer"
            onClick={() => {
              navigate("/dashboard/fileupload");
            }}
          >
            <Icon
              icon="ion:chevron-back-outline"
              width={20}
              height={18}
              color="#FFFFFF"
            />
            <label className="large fw-medium text-white roboto-family ">
              Back
            </label>
          </div>
          <div
            className="add-btn v-center h-center cursor-pointer"
            onClick={showeaddModal}
          >
            <Icon
              icon="zondicons:add-outline"
              width={30}
              height={23}
              color="#FFFFFF"
            />
          </div>
        </div>
        <div className="listingclient-table mt-4">
          <table className="m-auto">
            <thead>
              <tr className="send-email-thead ">
                <th>
                  <div className="  px-3">Document Type</div>
                </th>
                <th>Status</th>
                <th>Access Type</th>
                <th>Created By</th>
                <th>Edit</th>
                <th>Active/Inactive</th>
              </tr>
            </thead>
            <tbody>
              {visibleData.map((data, index) => (
                <tr key={data.id} className="send-email-tbody ">
                  <td className="first-td">
                    <div className=" v-center gap-4 px-3">{data.doctype}</div>
                  </td>

                  <td>
                    <div
                      className="active-inactive-div px-3 py-2 "
                      style={{
                        backgroundColor: getStatusBgColor(data.Status),
                        color: getStatusColor(data.Status),
                      }}
                    >
                      {data.Status}
                    </div>
                  </td>
                  <td>{data.accesstype}</td>
                  <td>{data.createdby}</td>
                  <td>
                    <img
                      onClick={showeditModal}
                      src="../../assets/icons/user-edit.svg"
                      alt="edit"
                      className=" cursor-pointer user-icon"
                    />
                  </td>
                  <td className="last-td">
                    <label className="switch">
                      <input type="checkbox" />
                      <span className="slider round"></span>
                    </label>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="listing-bottom h-center">
          <Pagination
            total={campaigndata.length}
            itemRender={itemRender}
            pageSize={itemsPerPage}
            onChange={handlePageChange}
            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
          />
        </div>
      </div>
      <EditdocpatternModal
        iseditModalOpen={iseditModalOpen}
        setiseditModalOpen={setiseditModalOpen}
      />
      <AdddocpatternModal
        adddocpatternmodal={adddocpatternmodal}
        setadddocpatternmodal={setadddocpatternmodal}
      />
    </>
  );
};

export default DocpatternListing;
